// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 PRO React examples
import SimpleInfoCard from "custom/Cards/InfoCards/SimpleInfoCard";

function Values() {
  return (
    <MKBox component="section" py={{ xs: 6, md: 12 }}>
      <Container>
        <Grid container item xs={12} lg={9} mx="auto">
          <MKTypography variant="h3" mb={8}>
            Nuestros Valores
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="gavel"
                title="Integridad"
                description="Mantener la honestidad, la ética y la transparencia en todas las transacciones comerciales fomenta la confianza entre los clientes, empleados y socios. Forma la base de relaciones sólidas y una reputación positiva."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="center_focus_weak"
                title="Orientación al Cliente"
                description="Priorizar las necesidades y la satisfacción de tus clientes impulsa la lealtad, el negocio recurrente y el boca a boca positivo. Poner a los clientes en el centro de tus decisiones asegura el éxito a largo plazo."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="biotech"
                title="Innovación"
                description="Adoptar la creatividad y la innovación permite a tu empresa mantenerse competitiva y adaptarse a las tendencias cambiantes del mercado. Buscar continuamente nuevas soluciones y enfoques puede llevar a avances y crecimiento."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="auto_awesome"
                title="Excelencia"
                description="Esforzarse por la excelencia en todos los aspectos de tu empresa, desde productos y servicios hasta interacciones con clientes y operaciones internas, demuestra un compromiso con la calidad y el profesionalismo que te distingue."
              />
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Values;